class SiteElementCollapsible
    extends QueryElement<HTMLElement> {


    constructor(element: HTMLElement) {
        super(element);

        var that = this;

        this.query(".collapsible-on").all(a => {
            a.on("click", (e) => {
                that.toggleClass("collapsed");
                e.stop();
            })
        });
    }

    async remove(removeInner?: boolean) {
        super.remove(removeInner);
    }

}